import React, { useEffect, useState } from 'react'
import { Arrow, AppCardIcon, CaseIcon } from '../../assets/index'
import { language } from '../../stores/slices/languageSlice'
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { fetchViewAppDetails, getMemberDetails, resetAppViewDetails, resetInitialTab, resetPDMICard } from '../../stores/slices/appViewDetailsSlice';
import { resetApplicationsDocLists } from '../../stores/slices/document/documentListSlice';
import { Paperclip, PlusCircle, Settings } from 'react-feather';
import { Modal, Tooltip } from "antd";
import { cancelNavigate } from '../../stores/slices/claimIntake/claimIntakeSlice';
import { toast } from 'react-toastify';
import { VIEW_CASE_REDIRECTION_URL } from '../../constant/Constants';
import { generateHashData } from '../../stores/slices/caseManagement/generateHashDataSlice';
import Input from '../input/Input';
import { updateEmailAPI } from '../../stores/slices/portalUserEmailUpdate/portalUserEmailUpdateSlice';
import validateInput from '../../utilities/validations/validateInput';

function Card1({ Program, appData }) {
    const selectedLanguage = useSelector(language);
    const preAuth = useSelector(state => state.preAuthSlice.headers)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const appCard = selectedLanguage.ApplicationCard;
    const CaseCard = selectedLanguage.CaseCard;
    const loginData = useSelector((state) => state.loginSlice)
    const createPatientLanguage = useSelector(language).PatientSearch.createPatient;
    const errorMessage = useSelector(language).errorMessage;

    const [allowedEmailDomains, setAllowedEmailDomains] = useState([])
    const [failureSFMsg, setFailureSFMsgs] = useState([])
    const [emailModal, setEmailModal] = useState(false);
    const [updateEmail, setUpdateEmail] = useState({
            email: {
                value: "",
                isValid: true,
            },
        })

    useEffect(() => {
        setUpdateEmail({
            email: {
                value: loginData.Email,
                isValid: true,
            },
        });
    }, [])

    const viewApp = async (e, appID, Program, Tab, appData) => {
        if (Program == "CASE") {
            const hashed = await dispatch(generateHashData({ portalUserId: loginData.value.PortalUserID, patienId: "" }))
            if (hashed?.payload?.HashDetails?.HashValue) {
                const hashData = hashed?.payload?.HashDetails?.HashValue
                window.open(`${VIEW_CASE_REDIRECTION_URL}?recordId=${appData.applications.applicationID}&token=${hashData}`, '_blank');
            } else {
                if (hashed?.payload?.ResponseDetails?.ResponseCode == "RE006" && hashed?.payload?.ResponseDetails?.AllowedEmailDomains && JSON.parse(hashed?.payload?.ResponseDetails?.AllowedEmailDomains?.length > 0)) {
                    setAllowedEmailDomains(JSON.parse(hashed?.payload?.ResponseDetails?.AllowedEmailDomains))
                    setFailureSFMsgs(hashed?.payload?.ResponseDetails?.message)
                    setEmailModal(true)
                } else {
                    toast.error("Something went wrong, Please try again in a few minutes");
                }
            }

        } else {
            dispatch(resetAppViewDetails());
            dispatch(resetApplicationsDocLists());
            dispatch(resetInitialTab(Tab));
            dispatch(fetchViewAppDetails({ applicationID: appID, prgData: Program }))
            dispatch(getMemberDetails({ memberId: appData.applications.PatientID, prgData: Program }))
            dispatch(cancelNavigate(true))

            Tab == 8 && dispatch(resetPDMICard())
            return navigate('/applications/Details')
        }
    }

    const updatePortalUserMail = () => {
        if (updateEmail.email.value != '' && updateEmail.email.isValid) {
            let data = {
                newEmail: updateEmail.email.value,
                existingEmail: loginData.value.EmailAddress,
            }
            dispatch(
                updateEmailAPI({ email: data, portalID: loginData.value.PortalUserID })
            )
        } else {
            toast.error(errorMessage.mandatoryFieldsToastErrorMessage)
        }
    }

    const emailOnChange = (e, fieldValidation) => {

        let inputValue = e.target.value;
        let inputName = e.target.name;

        let inputValidate = validateInput(inputValue, fieldValidation);
        setUpdateEmail((prevState) => ({
            ...prevState,
            [inputName]: {
                value: inputValidate.value,
                isValid: inputValidate.isValid
            }
        }))

    }


    return (
        <React.Fragment>
            {appData?.applications?.program == "CASE" ?
                <div className="report-box-2 intro-y mt-12 mt-sm-5">
                    <div className="box d-sm-flex">
                        <div className="px-8 py-12 d-flex flex-column justify-content-center flex-1">
                            <div className="fs-base mt-1 text-gray-600 dark-text-gray-600 ps-2"><AppCardIcon /><span className="ps-5">{appData?.applications?.program}</span></div>
                            <div className="position-relative fs-xl fw-medium mt-12 ms-0.5">{appData?.applications?.caseNumber}</div>
                            <div className={`report-box-2__indicator patientStatus ${appData?.applications?.PortalAppStatus == 'Closed' ? `bg-theme-6` : appData?.applications?.PortalAppStatus == 'Pending' ? `bg-yellow` : (appData?.applications?.PortalAppStatus == 'Attempted' || appData?.applications?.PortalAppStatus == 'In Progress' || appData?.applications?.PortalAppStatus == 'InProgress') ? `bg-theme-9` : `bg-default`} tooltip cursor-pointer w-20 ps-3`} >{appData?.applications?.PortalAppStatus}</div>
                            <div className="mt-4 text-gray-600 dark-text-gray-600 ps-2">{appData?.applications?.PatientFullName?.toUpperCase()}</div>
                            <button onClick={(e) => viewApp(e, appData?.applications?.ApplicationID, appData?.applications?.program, 1, appData)} className="btn btn-outline-secondary position-relative justify-content-start rounded-pill mt-12">
                                {CaseCard.viewCase}
                                <span className="w-8 h-8 position-absolute d-flex justify-content-center align-items-center bg-theme-1 text-white rounded-pill end-0 top-0 bottom-0 my-auto ms-auto me-0.5"> <Arrow /> </span>
                            </button>
                            <div className='d-flex flex-row mt-6'>
                                {appData?.applications?.IsPDMICardGenerated == 'true' || true && <Tooltip placement="top" title={'Pharmacy Card'} > <div className="w-8 h-8 d-flex justify-content-center align-items-center text-white rounded-pill end-0 top-0 bottom-0 h-15 m-2 cursor-pointer"> </div> </Tooltip>}
                                {appData?.applications?.IsEligibleForDoc == 'true' && <Tooltip placement="top" title={'Upload Documents'} > <div onClick={(e) => { viewApp(e, appData?.applications?.ApplicationID, appData?.applications?.program, 5, appData) }} className="w-8 h-8 d-flex justify-content-center align-items-center bg-theme-1 text-white rounded-pill end-0 top-0 bottom-0 h-15 m-2 cursor-pointer"> <Paperclip /> </div> </Tooltip>}
                                {appData?.applications?.IsEligibleForClaim == 'true' && <Tooltip placement="top" title={'Submit Claim'} > <div onClick={(e) => { viewApp(e, appData?.applications?.ApplicationID, appData?.applications?.program, 7, appData) }} className="w-8 h-8 d-flex justify-content-center align-items-center bg-theme-1 text-white rounded-pill end-0 top-0 bottom-0 h-15 m-2 cursor-pointer"> <PlusCircle /> </div> </Tooltip>}

                            </div>
                        </div>
                        <div className="px-8 py-12 d-flex flex-column justify-content-center flex-1 border-top border-top-sm-0 border-start-sm border-gray-300 dark-border-dark-5 border-dashed">
                            {/* <div className="text-gray-600 dark-text-gray-600 fs-xs">Patient ID</div>
                            <div className="mt-1.5 d-flex align-items-center">
                                <div className="fs-xs">{appData?.applications?.PatientID}</div></div>
                            <div className="text-gray-600 dark-text-gray-600 fs-xs mt-5">Case Number</div>
                            <div className="mt-1.5 d-flex align-items-center">
                                <div className="fs-xs">{appData?.applications?.caseNumber}</div></div> */}
                            <div className="text-gray-600 dark-text-gray-600 fs-xs">Case Owner</div>
                            <div className="mt-1.5 d-flex align-items-center">
                                <div className="fs-xs">{appData?.applications?.caseOwner}</div></div>
                            <div className="text-gray-600 dark-text-gray-600 two_rem_line_heigth mt-2"></div>
                            <div className="text-gray-600 dark-text-gray-600 fs-xs two_rem_line_heigth mt-5">Primary Contact</div>
                            <div className="mt-1.5 d-flex align-items-center">
                                <div className="fs-xs">{appData?.applications?.pointOfContactName}</div>
                            </div>
                            <div className="text-gray-600 dark-text-gray-600 two_rem_line_heigth mt-2"></div>
                            <div className="text-gray-600 dark-text-gray-600 fs-xs two_rem_line_heigth mt-5">Created Date</div>
                            <div className="mt-1.5 d-flex align-items-center">
                                <div className="fs-xs">{appData?.applications?.pxCreateDateTime}</div>
                            </div>
                            <div className="text-gray-600 dark-text-gray-600 two_rem_line_heigth mt-2"></div>
                            <div className="text-gray-600 dark-text-gray-600 fs-xs two_rem_line_heigth mt-5">Sub-Status</div>
                            <div className="mt-1.5 d-flex align-items-center">
                                <div className="fs-xs">{appData?.applications?.subStatus}</div>
                            </div>
                        </div>
                    </div>
                </div>
                :
                <div className="report-box-2 intro-y mt-12 mt-sm-5">
                    <div className="box d-sm-flex">
                        <div className="px-8 py-12 d-flex flex-column justify-content-center flex-1">
                            <div className="fs-base mt-1 text-gray-600 dark-text-gray-600 ps-2"><AppCardIcon /><span className="ps-5">{appData?.applications?.program == "CPR" ? "TotalAssist" : appData?.applications?.program}</span></div>
                            <div className="position-relative fs-xl fw-medium mt-12 ms-0.5">{appData?.applications?.ApplicationID}</div>
                            <div className={`report-box-2__indicator patientStatus ${appData?.applications?.PortalAppStatus == 'Denied' ? `bg-theme-6` : appData?.applications?.PortalAppStatus == 'Pending' ? `bg-yellow` : appData?.applications?.PortalAppStatus == 'Approved' ? `bg-theme-9` : `bg-default`} tooltip cursor-pointer w-20 ps-3`} >{appData?.applications?.PortalAppStatus}</div>
                            <div className="mt-4 text-gray-600 dark-text-gray-600 ps-2">{appData?.applications?.PatientFullName}</div>
                            <button onClick={(e) => viewApp(e, appData?.applications?.ApplicationID, appData?.applications?.program, 1, appData)} className="btn btn-outline-secondary position-relative justify-content-start rounded-pill mt-12">
                                {appCard.viewApplication}
                                <span className="w-8 h-8 position-absolute d-flex justify-content-center align-items-center bg-theme-1 text-white rounded-pill end-0 top-0 bottom-0 my-auto ms-auto me-0.5"> <Arrow /> </span>
                            </button>
                            <div className='d-flex flex-row mt-6'>
                                {appData?.applications?.IsPDMICardGenerated == 'true' && <Tooltip placement="top" title={'Pharmacy Card'} > <div onClick={(e) => { viewApp(e, appData?.applications?.ApplicationID, appData?.applications?.program, 8, appData) }} className="w-8 h-8 d-flex justify-content-center align-items-center bg-theme-1 text-white rounded-pill end-0 top-0 bottom-0 h-15 m-2 cursor-pointer"> <Settings /> </div> </Tooltip>}
                                {appData?.applications?.IsEligibleForDoc == 'true' && <Tooltip placement="top" title={'Upload Documents'} > <div onClick={(e) => { viewApp(e, appData?.applications?.ApplicationID, appData?.applications?.program, 5, appData) }} className="w-8 h-8 d-flex justify-content-center align-items-center bg-theme-1 text-white rounded-pill end-0 top-0 bottom-0 h-15 m-2 cursor-pointer"> <Paperclip /> </div> </Tooltip>}
                                {appData?.applications?.IsEligibleForClaim == 'true' && <Tooltip placement="top" title={'Submit Claim'} > <div onClick={(e) => { viewApp(e, appData?.applications?.ApplicationID, appData?.applications?.program, 7, appData) }} className="w-8 h-8 d-flex justify-content-center align-items-center bg-theme-1 text-white rounded-pill end-0 top-0 bottom-0 h-15 m-2 cursor-pointer"> <PlusCircle /> </div> </Tooltip>}

                            </div>
                        </div>
                        <div className="px-8 py-12 d-flex flex-column justify-content-center flex-1 border-top border-top-sm-0 border-start-sm border-gray-300 dark-border-dark-5 border-dashed">
                            <div className="text-gray-600 dark-text-gray-600 fs-xs">Award Year</div>
                            <div className="mt-1.5 d-flex align-items-center">
                                <div className="fs-xs">{appData?.applications?.AwardYear}</div></div>
                            <div className="text-gray-600 dark-text-gray-600 fs-xs mt-5">{appCard.patientBalance}</div>
                            <div className="mt-1.5 d-flex align-items-center">
                                <div className="fs-xs">{`$ ${Number.parseFloat(appData?.applications?.PatientBalance).toFixed(2)}`}</div></div>
                            <div className="text-gray-600 dark-text-gray-600 fs-xs mt-5">{appCard.fund}</div>
                            <div className="mt-1.5 d-flex align-items-center">
                                <div className="fs-xs">{appData?.applications?.DisplayName}</div></div>
                            <div className="text-gray-600 dark-text-gray-600 fs-xs mt-5">{appCard.lookBackDate}</div>
                            <div className="mt-1.5 d-flex align-items-center">
                                <div className="fs-xs">{appData?.applications?.AppLookBackDate}</div>
                            </div>
                            <div className="text-gray-600 dark-text-gray-600 fs-xs mt-5">{appCard.approvalDate}</div>
                            <div className="mt-1.5 d-flex align-items-center">
                                <div className="fs-xs">{appData?.applications?.AppApprovalDateTime}</div>
                            </div>
                            <div className="text-gray-600 dark-text-gray-600 fs-xs mt-5">{appCard.expiryDate}</div>
                            <div className="mt-1.5 d-flex align-items-center">
                                <div className="fs-xs">{appData?.applications?.AppExpirationDate}</div>
                            </div>
                        </div>
                    </div>
                </div>}
            <Modal
                title={failureSFMsg != undefined ? failureSFMsg : ""}
                open={emailModal}
                onOk={() => { updatePortalUserMail() }}
                onCancel={() => {
                    setUpdateEmail({
                        email: {
                            value: loginData.Email,
                            isValid: true,
                        },
                    });
                    setEmailModal(false);
                }}
                width={800}
                cancelText="Cancel"
                maskClosable={true}
                closeIcon={false}
                okText="Save"
                centered
            >
                <div className="mb-5">
                    <ul>
                        {typeof allowedEmailDomains != "undefined" && allowedEmailDomains.length > 0 && allowedEmailDomains.map((data) => {
                            return (
                                <li className="list-disc ms-5"> {data} </li>
                            )
                        })}
                    </ul>
                </div>
                <Input
                    id="email"
                    type="text"
                    name="email"
                    label={createPatientLanguage.email}
                    value={updateEmail.email.value}
                    isValid={updateEmail.email.isValid}
                    errorMsg={errorMessage.inputErrorMessage}
                    onChange={(e) => emailOnChange(e, "email")}
                    maxLength="100"
                />
            </Modal>
        </React.Fragment>
    )
}

export default Card1